export default __webpack_public_path__ + "static/3-16-0-0-3d2be0a17e40b1141c28bee35e7be174.jpg";